import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerImageStyle = css`
  width: fit-content;
  background-color: ${theme.colors.white};
  padding: ${theme.spacing(0.8)};
  margin-top: ${theme.spacing(2)};
`;

export const imageStyle = css`
  width: 300px;
  border-radius: ${theme.borderRadius.small};
`;

export const eSignContainerStyle = css`
  border-radius: ${theme.borderRadius.small};
  position: relative;
  padding-left: ${theme.spacing(1.5)};
  background-color: ${theme.colors.neutral[5]};
  margin-bottom: ${theme.spacing(2)};
  display: flex;
  padding-bottom: ${theme.spacing(2)};
  flex-direction: column;
`;

export const eSignLabelStyle = css`
  color: ${theme.colors.neutral[50]};
  font-size: 1rem;
  line-height: 1;
  padding: 0px ${theme.spacing(0.5)};
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 12px;
  transform-origin: left top;
  transform: scale(0.75) translateY(-65%);
  background-color: ${theme.colors.white};
`;
